import { Alert, AlertDescription } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

interface RiskWarningProps {
  className?: string;
}

/**
 * Standardised consumer-credit risk disclaimer ("Att låna kostar pengar.").
 * Single source of truth for the legally-required text — no warning icon,
 * rendered identically on every loan and credit surface.
 */
export const RiskWarning = ({ className }: RiskWarningProps) => (
  <Alert className={cn("border-destructive/30 bg-destructive/10", className)}>
    <AlertDescription className="text-xs leading-relaxed text-foreground">
      Att låna kostar pengar. Om du inte kan betala tillbaka skulden i tid riskerar du en
      betalningsanmärkning. Det kan leda till svårigheter att hyra bostad, teckna abonnemang och få
      nya lån. För stöd, vänd dig till budget- och skuldrådgivningen i din kommun. Kontaktuppgifter
      finns på{" "}
      <a
        href="https://www.konsumentverket.se"
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-primary"
      >
        konsumentverket.se
      </a>
    </AlertDescription>
  </Alert>
);

export default RiskWarning;
